import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

import { SectionWrapper } from '../OnboardingV2/Onboarding.styled';

export const FeatureContainer = styled.div`
	display: grid;
	grid-template-columns: 6rem 3fr 5rem;
	justify-content: space-between;
	max-width: 100%;
	gap: 1.5rem;
	padding: 2rem 1rem;
	cursor: pointer;
	border-radius: var(--small-border-radius);
	background: var(--background-2);
	border: 1px solid var(--border-color);
`;

export const TextContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 1rem;
	min-height: 10rem;
`;

export const ActionButtons = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
`;

export const Header = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
`;

export const PinButton = styled(Button)`
	margin-bottom: 2rem;

	&.yellow {
		background: var(--yellow-10);
		border-color: var(--yellow-30);
		color: var(--yellow);

		.button-text,
		.button-icon {
			color: var(--yellow);
		}
	}

	&.greyOutline {
		background: var(--background-1);
		border-color: var(--black-10);
		color: var(--black-70);
	}
`;

export const OtoFeaturesSectionWrapper = styled(SectionWrapper)`
	height: 70vh;
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 0;

	@media ${Breakpoints.tablet} {
		height: 60vh;
	}
`;

export const FixedHeader = styled.div`
	position: sticky;
	top: 0;
	left: 0;
	background: var(--white);
	padding: 2rem 2rem 1rem 2rem;
	z-index: 100;
	display: grid;
	grid-template-columns: 1fr 1fr;
`;

export const FeatureList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 0 2rem 1rem;

	@media ${Breakpoints.tablet} {
		gap: 2rem;
	}
`;
